import { useContext, useEffect } from 'react'
import { BreadCrumbContext, BreadCrumbDataContext } from 'app/crumbs/context/breadCrumbData'

export const useBreadCrumbDataContext = (): BreadCrumbContext => {
  const breadCrumbDataContext = useContext(BreadCrumbDataContext)

  useEffect(() => {
    // reset breadcrumb data so we won't show any old data in a breadcrumb
    return () => breadCrumbDataContext.setBreadCrumbData({})
  }, [])

  return breadCrumbDataContext
}
